<div class="navbar-menu-items-container nice-scroll colored-scroll-track">
	@for (menuItem of menuItems; track menuItem) {
		@if (isMenuItemVisible(menuItem)) {
			<div class="menu-item-wrapper">
				<menu-item-content
					[menuItem]="menuItem"
					[level]="0"
					(expandedChange)="onExpandToggle()"
				/>
			</div>
		}
	}
	@if (!isSettingsRoute) {
		<my-buildings-section class="m-t-xs" />
	}
</div>
